export enum EventVariant {
  'Personal' = 'personal',
  'Organised' = 'organised',
  'Other' = 'other',
}
